export enum ZatcaInvoiceState {
    None = 'None',
    Generated = 'Generated',
    Uploaded = 'Uploaded',
}

export const ZatcaInvoiceStateTranslations: Record<ZatcaInvoiceState, string> = {
    [ZatcaInvoiceState.None]: 'بدون',
    [ZatcaInvoiceState.Generated]: 'تم الإنشاء',
    [ZatcaInvoiceState.Uploaded]: 'تم الرفع',
};
